import {
  useLazyGetRecordingQuery,
  useRecordingDraftNewMutation,
} from '@carboncopyco/data';
import { TabType } from '@carboncopyco/types/desktop';
import { useTabs } from '../../store/context';
import rendererService from '../RendererService';
import { useTabManager } from '../TabManager';

export function useClonerService() {
  const [getRecording] = useLazyGetRecordingQuery();
  const { createGlobalTab } = useTabManager();
  const [recordingDraftNew] = useRecordingDraftNewMutation();
  const { setActiveRecordingData } = useTabs();

  const updateClone = async (organizationId: any, recordingId: any) => {
    try {
      const recording = await getRecording({
        organizationId: organizationId.toString(),
        id: recordingId.toString(),
      }).unwrap();

      const recordingDraft = await recordingDraftNew({
        organizationId,
        recordingId: recording.id?.toString() || '',
        url: encodeURIComponent(recording?.firstUrl || ''),
      }).unwrap();

      const tab = createGlobalTab({
        type: TabType.UPDATE_CLONE,
        url: decodeURIComponent(recording.firstUrl),
        cloneId: recordingId,
        organizationId,
        payload: { recording, recordingDraft },
      });
      setActiveRecordingData(recordingDraft);
      return rendererService.sendNewUpdateRecording(
        tab,
        organizationId,
        recordingId
      );
    } catch (error) {
      return console.log(error);
    }
  };

  return {
    updateClone,
  };
}
